module.exports = __webpack_public_path__ + "img/verified_check.3c90255f.svg";